<template>
  <div>
    <form class="xcard" @submit.prevent="validarCampos" style="margin-top: 0" novalidate>
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
      <h3 class="text-center">Editar Datos de {{ menu_name }}</h3>
      <p class="text-center">
        Los {{ menu_name }} creados son visibles para las demas sedes a nivel nacional, las demas sedes pueden reusar los datos de este {{ menu_name }} para
        crear sus propios programas.
      </p>
      <p class="text-center text-primary" style="margin-bottom: 0">
        <small class="center-block">
          <span class="glyphicon glyphicon-exclamation-sign"></span> Los campos con un asterisco <span class="text-danger">*</span> son obligatorios
        </small>
      </p>

      <p class="text-right">
        <button type="button" data-toggle="modal" data-target="#modal-narea" title="Crear Area" class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Nueva area
        </button>
      </p>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.idcategoria') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Categoria</div>
              <Categorias :model="postgrado" :default="postgrado.idcategoria" />
            </div>
            <div class="error" v-if="validation.hasError('postgrado.idcategoria')">{{ validation.firstError('postgrado.idcategoria') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.clase_netsuite_id') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger" v-show="clasesnet.length">*</span> Clase NetSuite</div>
              <multiselect
                class="form-control"
                v-model="postgrado.clase_netsuite_id"
                :options="clasesnet"
                track-by="id"
                label="nombre"
                :disabled="clasesnet.length == 0"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :loading="loading_clasesnet" 
                :placeholder="clasesnet.length?'Seleccione...':'No hay clases.'"/>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.clase_netsuite_id')">
              {{ validation.firstError('postgrado.clase_netsuite_id') }}
            </div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.idarea') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Area</div>
              <Areas :model="postgrado" :default="postgrado.idarea" />
            </div>
            <div class="error" v-if="validation.hasError('postgrado.idarea')">{{ validation.firstError('postgrado.idarea') }}</div>
          </div>

          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.nombre') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Nombre</div>
              <input type="text" v-model.trim="postgrado.nombre" class="form-control" placeholder="Nombre del postgrado" />
            </div>
            <div class="error" v-if="validation.hasError('postgrado.nombre')">{{ validation.firstError('postgrado.nombre') }}</div>
          </div>

          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.creditaje') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Creditaje</div>
              <input type="text" v-model.trim="postgrado.creditaje" class="form-control" placeholder="Numero entero (aun no hace nada)" />
              <span class="input-group-addon">Horas</span>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.creditaje')">{{ validation.firstError('postgrado.creditaje') }}</div>
          </div>

          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.duracion') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Duracion</div>
              <input type="text" v-model.trim="postgrado.duracion" class="form-control" placeholder="Numero entero" />
              <span class="input-group-addon">Meses</span>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.duracion')">{{ validation.firstError('postgrado.duracion') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.carga_horaria') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Carga horaria</div>
              <input type="text" v-model.trim="postgrado.carga_horaria" class="form-control" placeholder="Numero entero" />
              <span class="input-group-addon">Horas</span>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.carga_horaria')">{{ validation.firstError('postgrado.carga_horaria') }}</div>
          </div>

          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.unidad_duracion') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Unidad Duracion</div>
              <select class="form-control input-group" v-model="postgrado.unidad_duracion">
                <option value="0">Meses</option>
                <option value="1">Semanas</option>
                <option value="2">Dias</option>
                <option value="3">Horas</option>
              </select>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.unidad_duracion')">{{ validation.firstError('postgrado.unidad_duracion') }}</div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.dirigido') }">
            <label for="comment">Dirigido:</label>
            <textarea v-model.trim="postgrado.dirigido" class="form-control" placeholder="Texto a quien va dirigido el postgrado" rows="3"></textarea>
            <div class="error" v-if="validation.hasError('postgrado.dirigido')">{{ validation.firstError('postgrado.dirigido') }}</div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.objetivo') }">
            <label for="comment">Objetivo:</label>
            <textarea v-model.trim="postgrado.objetivo" class="form-control" placeholder="Objetivo del postgrado" rows="3"></textarea>
            <div class="error" v-if="validation.hasError('postgrado.objetivo')">{{ validation.firstError('postgrado.objetivo') }}</div>
          </div>
        </div>
      </div>

      <Alertas ref="alertar" />
      <NuevaArea />
      <p class="text-center">{{ msg }}</p>

      <p class="text-center"><b>NOTA:</b> Cuando el Programa pasa a la fase de aprobado ya no se puede realizar cambios.</p>
      <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block"><span class="glyphicon glyphicon-ok"></span> Guardar cambios</button>
    </form>
    <notifications group="auth" position="bottom right" />

    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator';
import gql from 'graphql-tag';
import Areas from '@/components/Areas.vue';
import Categorias from '@/components/ACategorias.vue';
import Alertas from '@/components/AAlertas.vue';
import NuevaArea from '@/components/ANewArea.vue';
import { mapState } from 'vuex';
import xaxios from '@/xaxios';

export default {
  data() {
    return {
      menu_name: process.env.VUE_APP_NAME_MENU,
      activo: true,
      msg: '',
      universidades: [],
      postgrados: [],
      sedes: [],
      gestiones: [],
      loading_clasesnet: false,
      postgrado: {
        idarea: null,
        idcategoria: null,
        nombre: null,
        fase: 0,
        portada: 'portadita',

        creditaje: null,
        duracion: null,
        dirigido: null,
        objetivo: null,
        carga_horaria: null,
        unidad_duracion: null,
      },
      clasesnet:[],
    };
  },
  components: { Areas, Categorias, Alertas, NuevaArea },
  validators: {
    'postgrado.idarea'(value) {
      return Validator.value(value).required();
    },
    'postgrado.idcategoria'(value) {
      return Validator.value(value).required();
    },
    'postgrado.clase_netsuite_id'(value) {
      if(this.clasesnet.length > 0) return Validator.value(value).required();
      return Validator.value(value);
    },
    'postgrado.nombre'(value) {
      return Validator.value(value).required().minLength(5);
    },
    'postgrado.portada'(value) {
      return Validator.value(value).required().minLength(5);
    },
    'postgrado.fase'(value) {
      return Validator.value(value).digit().required().maxLength(1).lessThan(3);
    },
    'postgrado.creditaje'(value) {
      return Validator.value(value).integer().minLength(0).required().maxLength(4).greaterThan(-1);
    },
    'postgrado.duracion'(value) {
      return Validator.value(value).integer().minLength(1).required().maxLength(3).greaterThan(0);
    },
    'postgrado.carga_horaria'(value) {
      return Validator.value(value).integer().minLength(1).required().maxLength(5).greaterThan(0);
    },
    'postgrado.unidad_duracion'(value) {
      return Validator.value(value).integer().minLength(1).maxLength(5).greaterThan(-1);
    },
    'postgrado.dirigido'(value) {
      return Validator.value(value).minLength(5).maxLength(499);
    },
    'postgrado.objetivo'(value) {
      return Validator.value(value).minLength(5).maxLength(499);
    },
  },

  /**
   * ME QUEDE VALIDANDO EL sesionStorage, al parecer aparece otros campos como categoria y area
   * que no deberian estar, porque da error en la consola
   * corregir eso 4/03/2020 15:44
   */
  watch: {
    postgrado: {
      deep: true,
      handler() {
        window.sessionStorage.setItem('xpostgrado', JSON.stringify(this.postgrado));
      },
    },
    'postgrado.idcategoria': function(){
      if(!this.postgrado.idcategoria) return; 
      this.getNetSuiteClase();
    }
  },
  computed: {
    ...mapState({
      postgrado_value: (state) => state.postgrado.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
  },
  methods: {
    validarCampos() {
      this.$validate().then((success) => {
        // window.console.log( "jajajajajaajajj" );
        var obj = window.Object.assign({}, this.postgrado);
        if (obj.duracion != null) obj.duracion = window.parseInt(obj.duracion);
        if (obj.unidad_duracion != null) obj.unidad_duracion = window.parseInt(obj.unidad_duracion);
        if (obj.creditaje != null) obj.creditaje = window.parseFloat(obj.creditaje);
        if (obj.carga_horaria != null) obj.carga_horaria = window.parseFloat(obj.carga_horaria);
        if(obj.clase_netsuite_id) obj.clase_netsuite_id = obj.clase_netsuite_id.id;
        
        if (success) {
          obj.idarea = obj.idarea.id;
          obj.idcategoria = obj.idcategoria.id;
          // estas acciones van en par, set el objeto para luego limpiar campos nulos
          this.$store.state.obj = obj;
          this.$store.dispatch('quitarNulos');

          delete obj.fase; // todavia no esta implemetado en el server

          this.activo = false;
          this.$refs.alertar.cargando();
          // window.console.log( "SSSSS",window.stringifyObject(obj) );
          this.enviarDatos(obj);
        } else {
          // window.console.log( "HHHHH",window.stringifyObject(obj) );
          this.$refs.alertar.invalido();
        }
      });
    },
    async enviarDatos(obj) {
      var vue = this;
      obj.unidad_negocio_id = this.UNIDAD_NEGOCIO_ID;
      // const obj = { id: this.postgrado.id, status: parseInt(this.postgrado.fase), unidad_negocio_id: this.UNIDAD_NEGOCIO_ID };
      delete obj.clasenetsuite;
      var sql = gql`mutation{ updatePostgrado(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      vue.msg = '';
      window.console.log('line 219', sql);

      this.$apollo
        .mutate({
          mutation: sql,
        })
        .then((data) => {
          if (data.data.updatePostgrado.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem('xpostgrado', null);
          } else {
            var errores = JSON.stringify(data.data.updatePostgrado.errors);
            var obj = JSON.parse(errores);
            var vals = '';
            obj.forEach(function (k) {
              vals += Object.values(k) + '-\n\t';
            });
            //vue.msg = vals;
            vue.activo = true;
            vue.$refs.alertar.invalido(vals);
          }

          // window.console.log(data);
        })
        .catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          //vue.msg = JSON.stringify(error);
          vue.msg = error;
        });
    },

    async getNetSuiteClase(){
        // window.console.log('this.postgrado',this.postgrado);
        this.postgrado.clase_netsuite_id = null;
        this.clasesnet = [];
        this.loading_clasesnet = true;
        let url = process.env.VUE_APP_API_REST+`/api/v1/esam/clasesnetsuite/${this.postgrado.idcategoria.clase_netsuite_id}`
        let res = await xaxios.get(url).then(x=>x).catch(e=>e);
        let clases = res.data;
        if(!clases) clases = [];
        // window.console.log('claseeee',clases);
        this.clasesnet = clases;
        this.loading_clasesnet = false;
        if(this.postgrado.clasenetsuite){
          let cn = this.postgrado.clasenetsuite;
          this.postgrado.clase_netsuite_id = clases.find(c=>c.id==cn.id);
        }
      },
  },
  mounted() {
    // window.console.log( 'postgrado_value',this.postgrado_value );
    if (this.postgrado_value) {
      const p = this.postgrado_value;
      this.postgrado.id = p.id;
      this.postgrado.nombre = p.nombre;
      this.postgrado.duracion = p.duracion;
      this.postgrado.carga_horaria = p.carga_horaria;
      this.postgrado.creditaje = p.creditaje;
      this.postgrado.dirigido = p.dirigido;
      this.postgrado.objetivo = p.objetivo;
      this.postgrado.unidad_duracion = p.unidad_duracion;
      this.postgrado.fase = p.status;
      this.postgrado.idarea = { id: p.area.id, nombre: p.area.nombre };
      this.postgrado.idcategoria = { id: p.categoria.id, nombre: p.categoria.nombre,clase_netsuite_id:p.categoria.clase_netsuite_id };
      this.postgrado.nombre = this.postgrado.nombre.replace(p.categoria.nombre, '').trim();
      this.postgrado.clasenetsuite = p.clasenetsuite;
      let idrol = this.$store.state.CARGO.id;
      //window.console.log(idrol,p.status)
      if(idrol == 1 ) this.activo = true;
      else this.activo = p.status < 1;
    }
  },
};
</script>